export const EPOCH_TIME_MS = {
  ONE_DAY: 86_400_000,
  ONE_WEEK: 604_800_000,
  ONE_MONTH: 2_592_000_000,
  ONE_YEAR: 31_536_000_000,
  SIX_MONTHS: 15_724_800_000,
  ALL_TIME: 0,
}
